import { UserOutlined } from '@ant-design/icons';
import { ProfileNavItem } from '@app/constants/profileNavData';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import { useAppSelector } from '@app/hooks/reduxHooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './ProfileNav.styles';

const profileNavData: ProfileNavItem[] = [
  {
    id: 1,
    name: 'profile.nav.personalInfo.title',
    icon: <UserOutlined />,
    color: 'primary',
    href: 'personal-info',
  },
  // {
  //   id: 2,
  //   name: 'profile.nav.chatInfo.titleAgent',
  //   icon: <WechatWorkOutlined />,
  //   color: 'warning',
  //   href: 'chat-info',
  // },
];

export const ProfileNav: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const user = useAppSelector((state) => state.user.user);

  const [navData, setNavData] = useState<ProfileNavItem[]>([]);

  React.useEffect(() => {
    if (user && !user?.role?.isAdministrator) {
      setNavData(
        profileNavData.map((item) => ({
          ...item,
          href: item.id > 1 ? `${item.href}/${user.id}` : item.href,
        })),
      );
    } else {
      setNavData(profileNavData.filter((item) => item.id === 1));
    }
  }, [user]);

  return (
    <S.Wrapper>
      {navData.map((item) => (
        <S.Btn
          key={item.id}
          icon={item.icon}
          type="text"
          color={item.color}
          onClick={() => navigate(item.href)}
          isActive={`${ADMIN_BASE_BATH}/profile/${item.href}` === location.pathname}
        >
          {`${t(item.name)}`}
        </S.Btn>
      ))}
    </S.Wrapper>
  );
};
